import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentTransactionsFilterComponent } from './components/scripts/paymentTransactionsFilter.component';
import { AuthGuard } from '../authentication/services/auth.guard.service';


const paymentTransactionsRoutes: Routes = [
 {
    path: 'paymentTransactions', component: PaymentTransactionsFilterComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'UserSiteManager']
    },
    children: [
      {
        path: '',
        children: [
          {
            path: 'filter',
            component: PaymentTransactionsFilterComponent,
            data: { preload: true }
          }
        ]
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(paymentTransactionsRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class PaymentTransactionsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/paymentTransactions-routing.module.ts